import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { primaryTags } from './utils';
/**
 * Homepage hero stats strip. Each metric is pushed only when it can be sourced
 * cleanly from live data, so the row degrades gracefully if an extension that
 * supplies it is absent.
 */
export default class HomeStats extends Component {
  view() {
    var _app$forum$attribute;
    const out = [];
    const fmt = n => n.toLocaleString();
    const t = key => app.translator.trans("glowingblue-demo.forum.home.stats.".concat(key));
    const tags = primaryTags();

    // Members — core forum attribute.
    const userCount = app.forum.attribute('userCount');
    if (typeof userCount === 'number') out.push({
      num: fmt(userCount),
      lbl: t('members')
    });

    // Discussions — prefer a forum-wide total; otherwise sum the primary-tag
    // counts (the same numbers shown on the topic tiles).
    const discussionTotal = (_app$forum$attribute = app.forum.attribute('discussionCount')) != null ? _app$forum$attribute : tags.reduce((sum, t) => {
      var _t$discussionCount;
      return sum + (((_t$discussionCount = t.discussionCount) == null ? void 0 : _t$discussionCount.call(t)) || 0);
    }, 0);
    if (discussionTotal) out.push({
      num: fmt(discussionTotal),
      lbl: t('discussions')
    });

    // Topics — primary (top-level) tags.
    if (tags.length) out.push({
      num: tags.length,
      lbl: t('topics')
    });

    // Online now — real-time presence (flarum core / flarum-realtime).
    const online = app.forum.attribute('onlineTotal');
    if (typeof online === 'number' && online > 0) out.push({
      num: fmt(online),
      lbl: t('online')
    });

    // Active poll.
    if (this.attrs.poll) out.push({
      num: 1,
      lbl: t('poll')
    });
    if (!out.length) return null;
    return m("div", {
      className: "HomeHero-stats"
    }, out.map(s => m("div", {
      className: "HomeHero-stat"
    }, m("div", {
      className: "HomeHero-stat-num"
    }, s.num), m("div", {
      className: "HomeHero-stat-lbl"
    }, s.lbl))));
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomeStats', HomeStats);